import { useAuth } from "@/components/AuthProvider";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login, authConfig } = useAuth();

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center font-body" data-testid="login-page">
      <div className="bg-white border border-[#E1DFDD] rounded-sm p-8 max-w-sm w-full text-center">
        <h1 className="font-heading text-xl font-semibold tracking-tight text-[#0F6CBD]">SignatureForge</h1>
        <p className="text-xs text-[#5E5E5E] mt-0.5 mb-6">M365 Signature Platform</p>

        <div className="border border-[#E1DFDD] rounded-sm p-6 mb-4">
          <ShieldCheck size={32} className="mx-auto text-[#0F6CBD]" />
          <h2 className="font-heading text-base font-medium text-[#171717] mt-3">Admin Sign In</h2>

          {authConfig?.entra_configured ? (
            <p className="text-xs text-[#5E5E5E] mt-2 mb-4">Sign in with your Microsoft Entra account</p>
          ) : (
            <div className="mt-3 mb-4">
              <div className="flex items-center gap-1.5 justify-center text-[10px] text-[#D83B01]">
                <AlertTriangle size={12} /> Entra SSO not configured
              </div>
              <p className="text-[10px] text-[#5E5E5E] mt-1">
                {authConfig?.dev_bypass
                  ? "Dev bypass is active. You'll be signed in as Dev Admin."
                  : "Set AZURE_TENANT_ID, AZURE_CLIENT_ID, AZURE_CLIENT_SECRET in backend/.env"}
              </p>
            </div>
          )}

          <Button
            onClick={login}
            className="w-full bg-[#0F6CBD] text-white hover:bg-[#005A9E] rounded-sm"
            data-testid="login-btn"
          >
            {authConfig?.entra_configured ? "Sign in with Microsoft" : "Sign in (Dev Mode)"}
          </Button>
        </div>

        <p className="text-[10px] text-[#5E5E5E]">
          {authConfig?.dev_bypass && (
            <span className="text-[#D83B01]">DEV BYPASS ACTIVE &middot; </span>
          )}
          Protected by Microsoft Entra ID
        </p>
      </div>
    </div>
  );
}
